/**
 * GoGo riders timeline
 * Line spans exactly first → last dot, centered on the dots.
 */
(() => {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  const scrollTargets = () => {
    const targets = [window];
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper) targets.push(wrapper);
    return targets;
  };

  const initSection = (section) => {
    const timeline = section.querySelector('[data-riders-timeline]');
    const line = section.querySelector('.gogo-riders__line');
    const fill = section.querySelector('[data-riders-fill]');
    const cards = [...section.querySelectorAll('[data-riders-card]')];
    const dots = cards.map((card) => card.querySelector('.gogo-riders__dot')).filter(Boolean);

    if (!timeline || !line || !cards.length || dots.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      cards.forEach((c, i) => c.classList.toggle('is-active', i === 0));
      if (fill) fill.style.height = '100%';
      return;
    }

    let active = null;
    let ticking = false;

    const setActive = (next) => {
      if (!next || next === active) return;
      cards.forEach((card) => card.classList.toggle('is-active', card === next));
      active = next;
    };

    const layoutLine = () => {
      const tRect = timeline.getBoundingClientRect();
      const first = dots[0].getBoundingClientRect();
      const last = dots[dots.length - 1].getBoundingClientRect();

      const x = first.left + first.width / 2 - tRect.left;
      const y1 = first.top + first.height / 2 - tRect.top;
      const y2 = last.top + last.height / 2 - tRect.top;

      line.style.left = `${x}px`;
      line.style.top = `${y1}px`;
      line.style.height = `${Math.max(0, y2 - y1)}px`;
      line.style.bottom = 'auto';
      line.style.transform = 'translateX(-50%)';
    };

    const update = () => {
      layoutLine();

      const mid = window.innerHeight * 0.45;
      let best = cards[0];
      let bestDist = Infinity;

      for (const card of cards) {
        const r = card.getBoundingClientRect();
        const center = r.top + r.height * 0.5;
        const dist = Math.abs(center - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = card;
        }
      }
      setActive(best);

      if (fill) {
        const first = dots[0].getBoundingClientRect();
        const last = dots[dots.length - 1].getBoundingClientRect();
        const start = first.top + first.height / 2;
        const end = last.top + last.height / 2;
        const progress = clamp((mid - start) / (end - start || 1), 0, 1);
        fill.style.height = `${progress * 100}%`;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => setActive(card));
    });

    scrollTargets().forEach((t) => {
      t.addEventListener('scroll', onScroll, { passive: true });
    });
    window.addEventListener('resize', onScroll, { passive: true });

    if (document.fonts?.ready) {
      document.fonts.ready.then(update);
    }
    update();
  };

  const init = () => {
    document.querySelectorAll('[data-gogo-riders]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
